<template>
  <pt-work-order-history-table class="pt-work-order-history-table__withData"  @getOrderWorkHistoryList="getOrderWorkHistoryList" :historyList="historyList" :page-size="page_size" :tableData="tableData" :totalNumber="totalNumber" ref="table">
    <slot />
  </pt-work-order-history-table>
</template>

<script>
import PtWorkOrderHistoryTable from './index'
export default {
  name: 'pt-work-order-history-table__withData',
  props: {
    historyList: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    'pt-work-order-history-table': PtWorkOrderHistoryTable
  },
  data () {
    return {
      totalNumber: 0,
      page_size: this.pageSize,
      tableData: [],
      page: 0
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getOrderWorkHistoryList(0)
        this.$refs.table.resetPage()
      }
    }
  },
  methods: {
    getOrderWorkHistoryList (page, next) {
      let data = {
        page: page,
        size: this.page_size
      }
      this.$store.dispatch('getOrderWorkHistoryList', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取预约类咨询工单导出历史失败')
      })
    }
  }
}
</script>
